import React, { useState } from 'react';
import {
  PhoneIcon, EmailIcon, GlobeIcon, LocationIcon,
  CalendarIcon, BuildingIcon, UsersIcon, HomeIcon,
  StarIcon, TrophyIcon, CheckIcon
} from '../components/Icons/Icons';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import PropertyCard from '../components/PropertyCard/PropertyCard';
import './AgencyProfile.css';

function AgencyProfile() {
  const [activeTab, setActiveTab] = useState('listings');

  const agency = {
    name: 'Premium Properties Ltd.',
    logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=400',
    verified: true,
    rating: 4.7,
    reviews: 342,
    established: '2008',
    location: 'Karachi, Pakistan',
    phone: '+92 21 3456 7890',
    email: 'info@premiumproperties.pk',
    website: 'www.premiumproperties.pk',
    about: `Premium Properties Ltd. is a leading real estate agency in Pakistan, specializing in luxury residential and commercial properties. Since 2008, we have been committed to providing exceptional service and expertise to our clients across Karachi and beyond.

Our team of experienced professionals brings deep market knowledge, strong negotiation skills, and a client-first approach to every transaction. We pride ourselves on our integrity, transparency, and dedication to helping our clients achieve their real estate goals.

With a portfolio of premium properties and a track record of successful deals, Premium Properties has established itself as a trusted name in the Pakistani real estate market. Whether you're buying, selling, or investing, our team is here to guide you every step of the way.`,
    services: [
      'Property Sales',
      'Property Rentals',
      'Investment Consulting',
      'Property Management',
      'Market Analysis',
      'Legal Assistance'
    ],
    specializations: [
      'Luxury Homes',
      'Commercial Properties',
      'Residential Apartments',
      'Investment Properties'
    ],
    achievements: [
      'Top Agency 2023',
      '500+ Properties Sold',
      'Award-Winning Service',
      '15+ Years in Business'
    ],
    offices: [
      { name: 'Main Office', address: 'Plot 123, DHA Phase 6, Karachi', phone: '+92 21 3456 7890' },
      { name: 'Clifton Branch', address: 'Block 4, Clifton, Karachi', phone: '+92 21 3456 7891' },
      { name: 'Gulberg Office', address: 'Main Boulevard, Gulberg, Lahore', phone: '+92 42 3456 7892' }
    ]
  };

  const agencyAgents = [
    {
      id: 1,
      name: 'Ahmed Khan',
      photo: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200',
      position: 'Senior Agent',
      experience: 12,
      properties: 87,
      rating: 4.8,
      verified: true
    },
    {
      id: 2,
      name: 'Sara Ali',
      photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200',
      position: 'Real Estate Consultant',
      experience: 8,
      properties: 64,
      rating: 4.7,
      verified: true
    },
    {
      id: 3,
      name: 'Hassan Mahmood',
      photo: 'https://images.unsplash.com/photo-1556157382-97eda2d62296?w=200',
      position: 'Property Specialist',
      experience: 10,
      properties: 75,
      rating: 4.9,
      verified: true
    },
    {
      id: 4,
      name: 'Fatima Noor',
      photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200',
      position: 'Commercial Agent',
      experience: 6,
      properties: 52,
      rating: 4.6,
      verified: true
    },
    {
      id: 5,
      name: 'Usman Sheikh',
      photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200',
      position: 'Luxury Homes Specialist',
      experience: 9,
      properties: 68,
      rating: 4.8,
      verified: true
    },
    {
      id: 6,
      name: 'Ayesha Malik',
      photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200',
      position: 'Investment Advisor',
      experience: 7,
      properties: 59,
      rating: 4.7,
      verified: true
    }
  ];

  const agencyListings = [
    {
      id: 1,
      images: ['https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800'],
      price: 'PKR 1.5 Crore',
      pricePerSqft: 'PKR 30,000/sq ft',
      title: 'Luxury 5 Bedroom Villa with Swimming Pool',
      location: 'DHA Phase 6, Karachi',
      beds: 5,
      baths: 6,
      area: '500 sq yd',
      type: 'House',
      postedDate: '2 days ago',
      featured: true,
      verified: true
    },
    {
      id: 2,
      images: ['https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800'],
      price: 'PKR 1.2 Crore',
      pricePerSqft: 'PKR 28,000/sq ft',
      title: 'Modern 4 Bedroom House',
      location: 'DHA Phase 5, Karachi',
      beds: 4,
      baths: 5,
      area: '400 sq yd',
      type: 'House',
      postedDate: '1 week ago',
      featured: false,
      verified: true
    },
    {
      id: 3,
      images: ['https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800'],
      price: 'PKR 1.8 Crore',
      pricePerSqft: 'PKR 32,000/sq ft',
      title: 'Spacious Villa with Garden',
      location: 'DHA Phase 7, Karachi',
      beds: 6,
      baths: 7,
      area: '600 sq yd',
      type: 'House',
      postedDate: '3 days ago',
      featured: true,
      verified: true
    },
    {
      id: 4,
      images: ['https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800'],
      price: 'PKR 85 Lac',
      pricePerSqft: 'PKR 8,500/sq ft',
      title: 'Premium 3 Bedroom Apartment',
      location: 'Clifton Block 4, Karachi',
      beds: 3,
      baths: 3,
      area: '2000 sq ft',
      type: 'Apartment',
      postedDate: '5 days ago',
      featured: false,
      verified: true
    },
    {
      id: 5,
      images: ['https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800'],
      price: 'PKR 2.5 Crore',
      pricePerSqft: 'PKR 35,000/sq ft',
      title: 'Ultra Luxury Penthouse',
      location: 'DHA Phase 8, Karachi',
      beds: 4,
      baths: 5,
      area: '700 sq yd',
      type: 'Penthouse',
      postedDate: '1 day ago',
      featured: true,
      verified: true
    },
    {
      id: 6,
      images: ['https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800'],
      price: 'PKR 95 Lac',
      pricePerSqft: 'PKR 9,000/sq ft',
      title: 'Elegant 2 Bedroom Flat',
      location: 'Gulshan-e-Iqbal, Karachi',
      beds: 2,
      baths: 2,
      area: '1500 sq ft',
      type: 'Apartment',
      postedDate: '4 days ago',
      featured: false,
      verified: false
    }
  ];

  const handleAgentClick = (agentId) => {
    console.log(`Navigate to agent profile: ${agentId}`);
    if (window.navigateTo) {
      window.navigateTo('agent-profile');
    }
  };

  const handleContact = (type) => {
    console.log(`Contact agency via ${type}`);
  };

  return (
    <div className="agency-profile-page">
      <Header />

      <div className="agency-profile-container">
        <div className="agency-profile-header">
          <div className="agency-hero">
            <div className="agency-hero-left">
              <div className="agency-logo-large">
                {agency.logo ? (
                  <img src={agency.logo} alt={agency.name} />
                ) : (
                  <div className="agency-logo-placeholder">
                    {agency.name.charAt(0)}
                  </div>
                )}
                {agency.verified && (
                  <div className="verified-badge-agency">
                    <CheckIcon size={14} color="white" />
                  </div>
                )}
              </div>

              <div className="agency-hero-info">
                <h1 className="agency-name-large">{agency.name}</h1>

                <div className="agency-meta-info">
                  <div className="meta-item-agency">
                    <LocationIcon size={16} color="var(--color-text-secondary)" />
                    <span>{agency.location}</span>
                  </div>
                  <div className="meta-item-agency">
                    <CalendarIcon size={16} color="var(--color-text-secondary)" />
                    <span>Established {agency.established}</span>
                  </div>
                </div>

                {agency.rating && (
                  <div className="agency-rating-large">
                    <div className="rating-stars-agency">
                      {[...Array(5)].map((_, index) => (
                        <StarIcon
                          key={index}
                          size={20}
                          color="#f59e0b"
                          filled={index < Math.floor(agency.rating)}
                        />
                      ))}
                    </div>
                    <span className="rating-text-agency">
                      {agency.rating} ({agency.reviews} reviews)
                    </span>
                  </div>
                )}
              </div>
            </div>

            <div className="agency-contact-card">
              <h3 className="contact-title-agency">Get in Touch</h3>

              <div className="contact-buttons-agency">
                <button className="contact-btn-agency btn-primary-agency" onClick={() => handleContact('call')}>
                  <PhoneIcon size={18} />
                  <span>Call Now</span>
                </button>

                <button className="contact-btn-agency btn-secondary-agency" onClick={() => handleContact('email')}>
                  <EmailIcon size={18} />
                  <span>Email</span>
                </button>

                <button className="contact-btn-agency btn-website" onClick={() => handleContact('website')}>
                  <GlobeIcon size={18} />
                  <span>Visit Website</span>
                </button>
              </div>

              <div className="contact-info-agency">
                <div className="contact-info-item-agency">
                  <PhoneIcon size={16} color="var(--color-text-secondary)" />
                  <span className="info-text-agency">{agency.phone}</span>
                </div>
                <div className="contact-info-item-agency">
                  <EmailIcon size={16} color="var(--color-text-secondary)" />
                  <span className="info-text-agency">{agency.email}</span>
                </div>
                <div className="contact-info-item-agency">
                  <GlobeIcon size={16} color="var(--color-text-secondary)" />
                  <span className="info-text-agency">{agency.website}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="agency-profile-content">
          <div className="agency-stats-row">
            <div className="stat-card-agency">
              <div className="stat-icon-agency">
                <BuildingIcon size={48} color="var(--color-primary)" />
              </div>
              <div className="stat-value-agency">{agency.offices.length}</div>
              <div className="stat-label-agency">Office Locations</div>
            </div>

            <div className="stat-card-agency">
              <div className="stat-icon-agency">
                <UsersIcon size={48} color="var(--color-primary)" />
              </div>
              <div className="stat-value-agency">{agencyAgents.length}</div>
              <div className="stat-label-agency">Professional Agents</div>
            </div>

            <div className="stat-card-agency">
              <div className="stat-icon-agency">
                <HomeIcon size={48} color="var(--color-primary)" />
              </div>
              <div className="stat-value-agency">{agencyListings.length}</div>
              <div className="stat-label-agency">Active Listings</div>
            </div>

            <div className="stat-card-agency">
              <div className="stat-icon-agency">
                <StarIcon size={48} color="var(--color-primary)" filled={true} />
              </div>
              <div className="stat-value-agency">{agency.rating}</div>
              <div className="stat-label-agency">Average Rating</div>
            </div>
          </div>

          <div className="agency-about-section">
            <h2 className="section-title-agency">About {agency.name}</h2>
            <p className="about-text-agency">{agency.about}</p>

            <div className="agency-info-grid">
              <div className="info-group-agency">
                <h3 className="info-title-agency">Our Services</h3>
                <div className="info-tags-agency">
                  {agency.services.map((service, index) => (
                    <span key={index} className="info-tag-agency">{service}</span>
                  ))}
                </div>
              </div>

              <div className="info-group-agency">
                <h3 className="info-title-agency">Specializations</h3>
                <div className="info-tags-agency">
                  {agency.specializations.map((spec, index) => (
                    <span key={index} className="info-tag-agency">{spec}</span>
                  ))}
                </div>
              </div>
            </div>

            <div className="achievements-section-agency">
              <h3 className="info-title-agency">Achievements & Awards</h3>
              <div className="achievements-grid-agency">
                {agency.achievements.map((achievement, index) => (
                  <div key={index} className="achievement-item-agency">
                    <TrophyIcon size={24} color="#f59e0b" />
                    <span className="achievement-text-agency">{achievement}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="offices-section">
              <h3 className="info-title-agency">Our Offices</h3>
              <div className="offices-grid">
                {agency.offices.map((office, index) => (
                  <div key={index} className="office-card">
                    <div className="office-icon">
                      <BuildingIcon size={32} color="var(--color-primary)" />
                    </div>
                    <h4 className="office-name">{office.name}</h4>
                    <p className="office-address">{office.address}</p>
                    <p className="office-phone">
                      <PhoneIcon size={14} color="var(--color-text-secondary)" />
                      {office.phone}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="agency-tabs-section">
            <div className="tabs-header">
              <button
                className={`tab-button ${activeTab === 'listings' ? 'active' : ''}`}
                onClick={() => setActiveTab('listings')}
              >
                Our Listings ({agencyListings.length})
              </button>
              <button
                className={`tab-button ${activeTab === 'agents' ? 'active' : ''}`}
                onClick={() => setActiveTab('agents')}
              >
                Our Agents ({agencyAgents.length})
              </button>
            </div>

            <div className="tabs-content">
              {activeTab === 'listings' && (
                <div className="listings-tab">
                  <div className="properties-grid-agency">
                    {agencyListings.map(property => (
                      <PropertyCard key={property.id} property={property} />
                    ))}
                  </div>
                </div>
              )}

              {activeTab === 'agents' && (
                <div className="agents-tab">
                  <div className="agents-grid">
                    {agencyAgents.map(agent => (
                      <div
                        key={agent.id}
                        className="agent-card-agency"
                        onClick={() => handleAgentClick(agent.id)}
                      >
                        <div className="agent-card-header-agency">
                          <div className="agent-photo-agency">
                            {agent.photo ? (
                              <img src={agent.photo} alt={agent.name} />
                            ) : (
                              <div className="agent-photo-placeholder-agency">
                                {agent.name.charAt(0)}
                              </div>
                            )}
                            {agent.verified && (
                              <div className="verified-badge-small">
                                <CheckIcon size={12} color="white" />
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="agent-card-content-agency">
                          <h3 className="agent-name-agency">{agent.name}</h3>
                          <p className="agent-position">{agent.position}</p>

                          <div className="agent-stats-agency">
                            <div className="stat-item-agency">
                              <CalendarIcon size={14} color="var(--color-text-secondary)" />
                              <span className="stat-text-small">{agent.experience}+ years</span>
                            </div>
                            <div className="stat-item-agency">
                              <HomeIcon size={14} color="var(--color-text-secondary)" />
                              <span className="stat-text-small">{agent.properties} listings</span>
                            </div>
                          </div>

                          {agent.rating && (
                            <div className="agent-rating-small">
                              <div className="rating-stars-small">
                                {[...Array(5)].map((_, index) => (
                                  <StarIcon
                                    key={index}
                                    size={12}
                                    color="#f59e0b"
                                    filled={index < Math.floor(agent.rating)}
                                  />
                                ))}
                              </div>
                              <span className="rating-value-small">{agent.rating}</span>
                            </div>
                          )}

                          <button className="view-profile-btn">View Profile</button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AgencyProfile;
